<script>
    import { info } from '../store';
    import _ from 'lodash';
    import Step4 from './Step4.svelte';
    import Step6 from './Step6.svelte';

    export let step;
    export let stepComponent;

    let disabled_once = true;
    let disabled_monthly = true;

    $: $info, checkStatus();

    function payOnce () {
        $info.payment_option = 'once';
        step = 6;
        stepComponent = Step6;
    }

    function payMonthly () {
        $info.payment_option = 'monthly';
        step = 6;
        stepComponent = Step6;
    }

    function checkStatus () {
        disabled_once = !(_.isFinite($info.amount_money_paid_once) && $info.amount_money_paid_once >= 0);
        disabled_monthly = !(_.isFinite($info.amount_money_paid_monthly) && $info.amount_money_paid_monthly >= 0);
    }

    function prev () {
        step = 4;
        stepComponent = Step4;
    }
</script>

<main>
    <div class="calculator-banometru-card active" id="card-5">
        <div class="text-center color-mov mb-4">
            <h2>Impuls inițial</h2>
        </div>

        <div class="container-700">
            <div class="text-center color-orange mb-4">
                <h2>Ai de făcut o alegere.</h2>
            </div>
            <div class="row">
                <div class="col-lg-6 text-center">
                    <div class="form-group mb-4">
                        <div class="lab text-center mb-1">Vin acum cu o sumă de bani (în aceeași monedă ca și creditele)</div>
                        <input type="number" class="form-control text-center" bind:value="{$info.amount_money_paid_once}" required>
                    </div>
                    <button class="buton bt-next-step" disabled={disabled_once} on:click="{payOnce}">Achit anticipat acum</button>
                </div>
                <div class="col-lg-6 text-center">
                    <div class="form-group mb-4">
                        <div class="lab text-center mb-1">Vin în fiecare lună cu o sumă de bani în plus (în aceeași monedă ca și creditele)</div>
                        <input type="number" class="form-control text-center" bind:value="{$info.amount_money_paid_monthly}" required>
                    </div>
                    <button class="buton bt-next-step" disabled={disabled_monthly} on:click="{payMonthly}">Achit anticipat în fiecare lună</button>
                </div>
            </div>
        </div>

        <div class="card-nav">
            <div class="bt-nav-calculator bt-prev bt-prev-step" on:click="{prev}">
                <div class="lab">Pasul anterior</div>
                <div class="icon"></div>
            </div>
        </div>
    </div>
</main>
